import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import RouteTitle from '../../../../presentation/RouteTitle';
import EtelAPI from '../../../../api/EtelAPI';

class EntityOffNetList extends React.Component {
  constructor( ) {
    super();
    this.state = {
      loading: false,
      ENTITY_ID: 0,
      entities: [],
      entityOptions: [],
      entityOffNetHistory: [],
      entityOffNetHistoryRows: [],
      showBatchReview: false,
      batchReviewRow: {}
    }
  }

  static getDerivedStateFromProps( props, state )  {
    let newState = state;
    let stateChanged = false;

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }
  
  componentDidMount( ) {
    this.setState( { 
      loading: true
    });
  }

  componentDidUpdate( prevProps, prevState, snapshot ) {
    if( this.state.loading !== prevState.loading ) {
      this.getViewData();   
    }
  }

  // API CALLS
  getEntities = ( ) => {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI('entities/offnet/entities');
      api.get().then( result => {
        resolve(result);
      }).catch( exception => {
        reject( exception );
      })
    } );
  }
 
  getEntityOffNetHistory = ( ENTITY_ID ) => {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI('entities/offnethistory');
      let parameters = [];
      if( ENTITY_ID !== undefined && ENTITY_ID !== null ) {
        parameters.push(
          {"ENTITY_ID": ENTITY_ID}          
        );
      }
      api.get(parameters).then( result => {
        resolve(result);
      }).catch( exception => {
        reject( exception );
      })
    } );
  }

  getViewData = ( ) => {
    let callbacks = [];
    callbacks.push(this.getEntities());
    if( this.state.ENTITY_ID !== undefined && this.state.ENTITY_ID !== null) {
      if( this.state.ENTITY_ID !== 0 ) {
        callbacks.push(this.getEntityOffNetHistory(this.state.ENTITY_ID))
      }
    }
    let all = () => Promise.all( callbacks ).then( ( results ) => {
      // Build the entities options
      const entities = results[0];
      const entityOptions = [];
      if( entities !== undefined ) {
        if( entities.length > 0 ) {
          entities.forEach( (option, index ) => {
            const optionKey = `entity-option-${index}`;
            entityOptions.push(
              <option key={optionKey} value={option.ENTITY_ID}>
                {option.ENTITY_NAME}
              </option>
            )
          });
        }
      }
      const entityOffNetHistory = results[1];
      const entityOffNetHistoryRows = [];
      if( entityOffNetHistory !== undefined && entityOffNetHistory !== null ) {
        if( entityOffNetHistory.length > 0 ) {
          entityOffNetHistory.forEach( ( row, index ) => {
            const rowKey = `entity-history-row-${index}`
            let rowStyle = {};
            const gridRow = `${index+1} / ${index+2}`;
            rowStyle.gridRow = gridRow;
            entityOffNetHistoryRows.push(
              <span key={rowKey} className="entity-off-net-content-body-row" style={rowStyle}>
                <span className="entity-off-net-content-body-cell-1" >
                  <span>{row.CREATED_DATE}</span>
                </span>
                <span className="entity-off-net-content-body-cell-2" >
                  <span>{row.BATCH}</span>
                </span>
                <span className="entity-off-net-content-body-cell-3" >
                  <span>{row.TOTAL_CURRENT}</span>
                </span>
                <span className="entity-off-net-content-body-cell-4" >
                  <span>{row.TOTAL_DELETED}</span>
                </span>
                <span className="entity-off-net-content-body-cell-5" >
                  <span>{row.TOTAL_INSERTED}</span>
                </span>
                <span className="entity-off-net-content-body-cell-last" >
                  <span>{row.TOTAL_ANIS}</span>
                </span>
              </span>              
            );
          });
        }

      }
      this.setState( { 
        entityOffNetHistory: entityOffNetHistory,
        entityOffNetHistoryRows: entityOffNetHistoryRows,
        entities: entities,
        entityOptions: entityOptions,
        loading: false
      });
    }).catch( ( exception ) => {
      // TODO
      console.log( exception );
    });
    all();
  }

  getEntityOffNet = ( ENTITY_ID ) => {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI('entities/offnet');
      let parameters = [];
      if( ENTITY_ID !== undefined && ENTITY_ID !== null ) {
        parameters.push(
          {"ENTITY_ID": ENTITY_ID}          
        );
      }
      api.get(parameters).then( result => {
        resolve(result);
      }).catch( exception => {
        reject( exception );
      })
    } );
  }

  getEntityOffNetStage = ( ENTITY_ID, BATCH ) => {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI('entities/offnet');
      let parameters = [];
      // Validate the ENTITY_ID is set
      if( ENTITY_ID !== undefined && ENTITY_ID !== null && ENTITY_ID !== 0) {
        resolve([]);
        return;
      }
      
      // Validate the BATCH is set
      if( BATCH !== undefined && BATCH !== null && BATCH !== 0 ) {
        resolve([]);
        return;
      }

      // Get the list of off net that were staged all the
      // current, inserted and deleted
      api.get(parameters).then( result => {
        resolve(result);
      }).catch( exception => {
        reject( exception );
      })
    } );
  }

  // CONTROL EVENTS
  onChangeEntity = ( e ) => {
    this.setState( { 
      ENTITY_ID: e.target.value
    });
  }

  onSearch = ( e ) => {
    this.setState( { 
      loading: true
    },() => {
      this.getViewData();
    });
  }

  onClickList = ( row, e )  => {
    this.setState( { 
      showBatchReview: true,
      batchReviewRow: row
    }, () => {
      this.getBatchReviewData()
    });
  }

  onCloseBatchReview = ( e ) => {
    this.setState( { 
      showBatchReview: false,
      batchReviewRow: {}
    });
  }

  // RENDER FUNCTIONS
  onRenderHeader = ( ) => {
    return (
    <div className="entity-off-net-header">
      <span>
        Entity Off Net
      </span>
    </div>
    );
  }

  onRenderFilter = () => {
    let controls = [];
    controls.push(
      <span key="filter-control-entity-label">Entity</span>
    );
    controls.push(
      <select key="filter-control-entity-dropdown" value={this.state.ENTITY_ID} onChange={this.onChangeEntity}>
        {this.state.entityOptions}
      </select>
    );
    controls.push(
      <button type="text" key="filter-control-search-button" onClick={this.onSearch}>
        Search
      </button>
    );
    return (
      <div className="entity-off-net-filter">
        {controls}            
      </div>
    );
  }

  onRenderContent = ( ) => {
    let bodyStyle = {};
    let rows = [];
    const rowHeight = "50px "
    if( this.state.entityOffNetHistory !== undefined ) {
      if( this.state.entityOffNetHistory.length > 0 ) {
        bodyStyle.gridTemplateRows = rowHeight.repeat(this.state.entityOffNetHistoryRows.length).trim();
        rows = this.state.entityOffNetHistoryRows;
      } else {
        bodyStyle.gridTemplateRows = rowHeight;
        rows.push(
          <span key="entity-off-net-content-body-row-no-data" className="entity-off-net-content-body-row">
            <span className="entity-off-net-content-body-row-no-data">
              <span>
                Please select entity from dropdown  
              </span>
            </span>
          </span>      
        );
      }
    } else {
      bodyStyle.gridTemplateRows = rowHeight;
      rows.push(
        <span key="entity-off-net-content-body-row-no-data" className="entity-off-net-content-body-row">
          <span className="entity-off-net-content-body-row-no-data">
            <span>
              Please select entity from dropdown  
            </span>
          </span>
        </span>      
      );
    }
    return (
      <div className="entity-off-net-content">
        <div className="entity-off-net-content-header">
        <span className="entity-off-net-content-header-column-1">
            <span>Created</span>
          </span>
          <span className="entity-off-net-content-header-column-2">
            <span>Batch</span>
          </span>
          <span className="entity-off-net-content-header-column-3">
            <span>Current</span>
          </span>
          <span className="entity-off-net-content-header-column-4">
            <span>Deleted</span>
          </span>
          <span className="entity-off-net-content-header-column-5">
            <span>Inserted</span>
          </span>
          <span className="entity-off-net-content-header-column-last">
            <span>Total</span>
          </span>
        </div>
        <div className="entity-off-net-content-body" style={bodyStyle}>
          {rows}
        </div>
      </div>
    );
  }

  onRenderFooter = ( ) => {
    let footerMessage = "There are no records.";
    if( this.state.entityOffNetHistory !== undefined ) {
      if( this.state.entityOffNetHistory.length > 0 ) {
        if( this.state.entityOffNetHistory.length > 1 ) {
          footerMessage = `There are ${this.state.entityOffNetHistory.length} imported off net files.`
        } else  {
          footerMessage = `There is ${this.state.entityOffNetHistory.length} imported off net files.`
        }
      }
    }
    return (
      <div className="entity-off-net-footer">
        <span>{footerMessage}</span>
      </div>
    )
  }

  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations']}>
        <RouteTitle caption="Entity Off Net" />
        <div className="entity-off-net">
          {this.onRenderHeader()}
          {this.onRenderFilter()}
          {this.onRenderContent()}
          {this.onRenderFooter()}
        </div>
      </PageAuthorize>
    );
  }
}

export default EntityOffNetList;



// WEBPACK FOOTER //
// ./src/content/entities/offnet/components/EntityOffNetList.js